import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "avatar", "icon"]

  connect() {
    // Listen to toggle changes
    this.boundChange = event => { if (event.target.name === "show_participant_names") this.toggleNames() }
    this.element.addEventListener("change", this.boundChange)

    // Set initial state
    this.updateDisplay()
  }

  disconnect() {
    this.element.removeEventListener("change", this.boundChange)
  }

  toggleNames() {
    this.updateDisplay()
  }

  updateDisplay() {
    const checkbox = this.element.querySelector('input[name="show_participant_names"]')
    const showNames = checkbox ? checkbox.checked : true

    // Toggle names display
    this.nameTargets.forEach((nameElement) => {
      const displayName = nameElement.dataset.displayName
      const participantNumber = nameElement.dataset.participantNumber

      nameElement.textContent = showNames ? displayName : `${nameElement.dataset.subjectLabel || "Participant"} ${participantNumber}`
    })

    // Toggle avatar/icon display
    this.avatarTargets.forEach((avatar) => {
      if (showNames) {
        avatar.classList.remove("hidden")
      } else {
        avatar.classList.add("hidden")
      }
    })

    this.iconTargets.forEach((icon) => {
      if (showNames) {
        icon.classList.add("hidden")
      } else {
        icon.classList.remove("hidden")
      }
    })
  }
}
